var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-link" },
    [
      _c(
        "base-button",
        {
          staticClass: "button--icon",
          on: {
            click: function($event) {
              return _vm.$store.dispatch("cart/openSidecart")
            }
          }
        },
        [
          _c("span", { class: { "u-sr-only": !_vm.hideIcon } }, [
            _vm._v("Cart")
          ]),
          !_vm.hideIcon
            ? _c("icon", {
                staticClass: "button__icon",
                attrs: { name: "cart" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.numCartItems > 0
        ? _c("span", { staticClass: "cart-link__quantity" }, [
            _c("span", { staticClass: "cart-link__count" }, [
              _vm._v(_vm._s(_vm.numCartItems))
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }